import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/LoadingSpinner';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();

  useEffect(() => {
    const handleAuthCallback = async (): Promise<void> => {
      const token = searchParams.get('token');
      const error = searchParams.get('error');

      if (error) {
        toast.error('Authentication failed. Please try again.');
        navigate('/login', { replace: true });
        return;
      }

      if (token) {
        try {
          await login(token);
        } catch (error) {
          console.error('Login failed:', error);
          navigate('/login', { replace: true });
        }
      } else {
        toast.error('No authentication token received.');
        navigate('/login', { replace: true });
      }
    };

    handleAuthCallback();
  }, [searchParams, login, navigate]);

  return (
    <div className="min-h-screen bg-secondary-50 flex items-center justify-center">
      <div className="text-center">
        <LoadingSpinner size="lg" />
        <p className="mt-4 text-secondary-600">
          Completing authentication...
        </p>
      </div>
    </div>
  );
};

export default AuthCallback; 